export enum ROLE {
	OWNER = 'OWNER',
	SUPERVISOR = 'SUPERVISOR',
	EXTERNAL_SUPERVISOR = 'EXTERNAL_SUPERVISOR',
	EMPLOYEE = 'EMPLOYEE',
	EXTERNAL = 'EXTERNAL',
}
